import { ThemeSchemaResponse } from '@api';
import { SectionTitle } from '@terminal/components/section-title/SectionTitle';
import { TeamsGuard } from '@terminal/config/TeamsGuard';
import { useNavigateToThemeOverview } from '@terminal/hooks/use-navigate-to-theme-overview/useNavigateToThemeOverview';
import { queryKeys } from '@terminal/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { ThemeLogoIcon } from '@terminal/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';
import { useTranslation } from 'react-i18next';

import sharedStyles from '../theme-knowledge-graph/LegacyThemeKnowledgeGraph.module.scss';

const THEME_COMPETITOR_OVERVIEW = 'overview';

export const CompetingThemes = ({
  competingThemes,
  limit = 3,
}: {
  competingThemes: ThemeSchemaResponse[];
  limit?: number;
}) => {
  const { t } = useTranslation(['widget']);
  const { navigateToTheme } = useNavigateToThemeOverview();

  if (!competingThemes.length) {
    return null;
  }

  const handleSelectTheme = (themeId: string) => {
    const searchParams = new URLSearchParams();
    searchParams.set(queryKeys.activeSubTab, THEME_COMPETITOR_OVERVIEW);
    navigateToTheme({
      themeId,
      source: POSTHOG_TRACKING_SOURCES.COMPETITORS_DRAWER,
      searchParams,
    });
  };

  return (
    <div>
      <SectionTitle
        title={t(
          'assetOverview.knowledgeGraph.competitors.tabs.competitorOverview.competingThemes'
        )}
        variant="small"
      />
      <TeamsGuard>
        <div>
          {competingThemes.slice(0, limit).map((t: ThemeSchemaResponse) => (
            <div
              className={sharedStyles.themeRow}
              data-theme-row
              onClick={() => handleSelectTheme(t.id)}
              key={t.name}
            >
              <div className={sharedStyles.themeNameWrapper}>
                <ThemeLogoIcon
                  name={t.name}
                  logo_url={t.logo_url}
                  fallbackIcon={
                    <div className={sharedStyles.logoWrapper}>
                      {t.name.charAt(0)}
                    </div>
                  }
                />
                <span className={sharedStyles.themeName}>{t.name}</span>
              </div>
            </div>
          ))}
        </div>
      </TeamsGuard>
    </div>
  );
};
